import { render, staticRenderFns } from "./deleteitem.vue?vue&type=template&id=3aa1b36c&"
import script from "./deleteitem.vue?vue&type=script&lang=js&"
export * from "./deleteitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports